import type { OrderLineItem } from "../types";

export type LineItemDisplay = {
  title: string;
  subtitle: string | null;
  image: string | null;
};

export function getLineItemDisplay(
  lineItems: OrderLineItem[],
  lineItemId: string,
): LineItemDisplay {
  const item = lineItems.find((li) => li.line_item_id === lineItemId);
  if (!item) return { title: lineItemId, subtitle: null, image: null };

  const options = [item.variant.option1, item.variant.option2, item.variant.option3]
    .filter(Boolean)
    .join(" / ");

  return {
    title: item.title,
    subtitle: options || null,
    image: item.image ?? null,
  };
}
